module.exports = __webpack_public_path__ + "img/profile.65d6ab4b.png";